const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

class HeaderGriuyp extends HTMLElement {
  constructor() {
    super();
    this.groupInnher = this.querySelectorAll('.section-announcement');
    this.sectionHeader = this.querySelector('.section-header');
    this.handleResize = this.calculateGroupHeight.bind(this);
    this.sectionResizeObservers = [];
    this.groupHeight = "0px"
    this.headeManiHeight = "0px"
  }

  connectedCallback() {
    if (this.componentInitialized) return;
    this.componentInitialized = true;
    this.init();
    window.addEventListener('resize', this.handleResize, { passive: true });
    document.addEventListener('shopify:section:load', this.handleResize);
    document.addEventListener('shopify:section:reorder', this.handleResize);
    document.addEventListener('shopify:section:unload', this.handleResize);
  }

  disconnectedCallback() {
    this.componentInitialized = false;
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('shopify:section:load', this.handleResize);
    document.removeEventListener('shopify:section:reorder', this.handleResize);
    document.removeEventListener('shopify:section:unload', this.handleResize);
    this.disconnectObservers();
  }
  init() {
    this.refreshReferences();
    this.calculateGroupHeight();
    this.observeSectionChanges();
    this.stormApply()
  }
  stormApply() {
    this.style.setProperty('--header-group-offset', `${this.groupHeight}`);
  }
  refreshReferences() {
    this.groupInnher = this.querySelectorAll('.section-announcement');
    this.sectionHeader = document.querySelector('.section-header');
    this.headerMinmize = this.querySelector('header-minmize');
    this.headerMinmizeAtt = this.headerMinmize?.getAttribute('data-sticky');
  }

  observeSectionChanges() {
    if (typeof ResizeObserver === 'undefined') return;
    this.disconnectObservers();
    this.sectionResizeObservers = Array.from(this.groupInnher).map((section) => {
      const observer = new ResizeObserver(this.handleResize);
      observer.observe(section);
      return observer;
    });
    if (this.sectionHeader) {
      const headerObserver = new ResizeObserver(this.handleResize);
      headerObserver.observe(this.sectionHeader);
      this.sectionResizeObservers.push(headerObserver);
    }
  }

  disconnectObservers() {
    this.sectionResizeObservers.forEach((observer) => observer.disconnect());
    this.sectionResizeObservers = [];
  }

  calculateGroupHeight() {
    this.refreshReferences();
    this.stormApply()

    if (!this.groupInnher.length) return;
    const totalHeight = Array.from(this.groupInnher).reduce((height, section) => height + section.offsetHeight, 0);
    const headerHeight = this.sectionHeader?.offsetHeight || 0;
    const computedHeight = Math.max(totalHeight - headerHeight, 0);

    this.groupHeight = `${computedHeight}px`;

    const headerMinmizeHeight = this.headerMinmize?.offsetHeight || 0;
    this.headeManiHeight = `${headerMinmizeHeight}px`;

  }
}
window.addEventListener('DOMContentLoaded', () => {
  customElements.define("header-group-area", HeaderGriuyp);
})

class HeaderMinimize extends HTMLElement {
  constructor() {
    super();

    this.lastScroll = 0;
    this.menuIcon = null;
    this.menuDrawer = null;
    this.closeBtn = null;
    this.body = document.body;
    this.htmlElement = document.documentElement;
    this.headerMenu = null;
    this.headerBgOverlay = null;
    this.headerGroupArea = null;

    this.disclosureButtons = [];
    this.menuItems = [];
    this.drawerSearch = null;
    this.drawerMark = null;
    this.drawerOverlay = null;
    this.drawerSerch = null;
    this.drawerSerchClose = null;

    this.activeParentClass = 'menu-open';
    this.activeHeaderClass = 'menu-active';
    this.activeDisclosureParentClass = 'menu-active';
    this.escapeClosedClass = 'menu-escape-closed';

    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onMenuKeydown = this.onMenuKeydown.bind(this);
    this.onSearchDrawerKeydown = this.onSearchDrawerKeydown.bind(this);
    this.onHeaderMenuFocusIn = this.onHeaderMenuFocusIn.bind(this);
    this.onHeaderMenuFocusOut = this.onHeaderMenuFocusOut.bind(this);
    this.onHeaderMenuKeydown = this.onHeaderMenuKeydown.bind(this);
  }

  connectedCallback() {
    if (this.componentInitialized) return;
    this.componentInitialized = true;
    this.refreshReferences();
    this.attachListeners();
    this.discloseAll();
    this.handleScroll();


    if (!this.mutationObserver) {
      this.mutationObserver = new MutationObserver(() => this.refreshReferences());
      this.mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  disconnectedCallback() {
    this.componentInitialized = false;
    this.detachListeners(); if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    window.removeEventListener("scroll", this.handleScroll);
  }

  refreshReferences() {
    this.menuIcon = this.querySelector("#header-menu-icon");
    this.menuDrawer = this.querySelector("#menu-drawer-container");
    this.closeBtn = this.querySelector("#drawer-menu-close-btn");
    this.headerMenu = this.querySelector('.snazzy-header');
    this.headerBgOverlay = document.querySelector('.header-bg-overlay');
    this.headerGroupArea = document.querySelector('header-group-area');

    this.disclosureButtons = this.querySelectorAll('.disclosure__button');
    this.menuItems = this.querySelectorAll('.header-menu ul li .main-menu-has-sub-menu');

    this.drawerSearch = this.querySelector('#search-toggle');
    this.drawerMark = document.querySelector('#search-drawer');
    this.drawerOverlay = document.querySelector('#drawer-overlay');
    this.drawerSerch = document.querySelector('#Search-In-Modal');
    this.drawerSerchClose = document.querySelector('.search-close');
  }

  attachListeners() {
    if (this.menuIcon && this.menuDrawer) {
      this.menuIcon.addEventListener("click", this.toggleMenu);
      this.menuIcon.addEventListener("keydown", this.onMenuKeydown);
    }
    if (this.closeBtn && this.menuDrawer) {
      this.closeBtn.addEventListener("click", this.closeMenu);
    }
    if (this.headerMenu) {
      this.headerMenu.addEventListener("focusin", this.onHeaderMenuFocusIn);
      this.headerMenu.addEventListener("focusout", this.onHeaderMenuFocusOut);
      this.headerMenu.addEventListener("keydown", this.onHeaderMenuKeydown);
    }
    this.drawerMark?.addEventListener("keydown", this.onSearchDrawerKeydown);
    document.addEventListener("pointerdown", this.onDocumentPointerDown);
    document.addEventListener("keydown", this.onDocumentKeydown);
  }
  detachListeners() {
    if (this.menuIcon) {
      this.menuIcon.removeEventListener("click", this.toggleMenu);
      this.menuIcon.removeEventListener("keydown", this.onMenuKeydown);
    }
    if (this.closeBtn) this.closeBtn.removeEventListener("click", this.closeMenu);
    document.removeEventListener("pointerdown", this.onDocumentPointerDown);
    document.removeEventListener("keydown", this.onDocumentKeydown);
    if (this.headerMenu) {
      this.headerMenu.removeEventListener("focusin", this.onHeaderMenuFocusIn);
      this.headerMenu.removeEventListener("focusout", this.onHeaderMenuFocusOut);
      this.headerMenu.removeEventListener("keydown", this.onHeaderMenuKeydown);
    }
    this.drawerMark?.removeEventListener("keydown", this.onSearchDrawerKeydown);
  }
  isOpen() {
    return drawer.classList.contains('drawer-open') && drawer.getAttribute('aria-hidden') === 'false';
  }
  openDrawer(open) {
    if (!this.drawerSearch || !this.drawerMark) return;
    this.drawerSearch.setAttribute('aria-expanded', open);
    this.drawerMark.setAttribute('aria-hidden', !open);
    this.drawerMark.classList.toggle('drawer-open', open);

    if (open) {
      this.body.classList.add('drawer-open');
      this.drawerMark.removeAttribute('inert');
      this.drawerMark.setAttribute('tabindex', '-1');
      if (typeof trapFocus === 'function') {
        trapFocus(this.drawerMark, this.drawerSerch || this.drawerMark);
      } else {
        this.drawerMark.focus();
        this.drawerSerch?.focus();
      }
    } else {
      this.body.classList.remove('drawer-open');
      this.drawerMark.removeAttribute('tabindex');
      this.drawerMark.setAttribute('inert', '');

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.drawerSearch);
      } else {
        this.drawerSearch.focus();
      }
    }

  }

  discloseAll() {
    const toggleClasses = (element, parentClass) => {
      if (!element) return;
      const isActive = element.classList.contains(parentClass);
      this.closeAll();
      if (!isActive) {
        element.classList.add(parentClass);
        this.headerBgOverlay?.classList.add('active');
        this.body.classList.add('drawer-open-header');
        this.headerMenu?.classList.add(this.activeHeaderClass);
      }
      this.syncHeaderMenuAria();
    };

    this.disclosureButtons.forEach(button => {
      button.addEventListener('click', e => {
        e.stopPropagation();
        const parent = button.closest('.disclosure');
        toggleClasses(parent, this.activeDisclosureParentClass);
      });
    });

    this.menuItems.forEach(item => {
      const topLevelLink = item.querySelector(':scope > a.header-menu-item[href]');
      const toggleButton = item.querySelector(':scope > .header-menu-toggle');
      const buttonTrigger = item.querySelector(':scope > .header-menu-item[role="button"]');
      const trigger = topLevelLink ? toggleButton : buttonTrigger;

      const openSubmenu = (e) => {
        if (e.target.closest('.header__submenu')) return;

        e.preventDefault();
        e.stopPropagation();
        item.classList.remove(this.escapeClosedClass);

        const parentItem = item.closest('li');
        const isOpen = parentItem?.classList.contains(this.activeParentClass);

        toggleClasses(parentItem, this.activeParentClass);
        trigger?.setAttribute('aria-expanded', (!isOpen).toString());
        this.syncHeaderMenuAria();
      };

      if (topLevelLink) {
        toggleButton?.addEventListener('click', openSubmenu);
      } else {
        item.addEventListener('click', openSubmenu);
        // role="button" divs don't fire click on Enter/Space — add keyboard activation (a11y: WCAG 2.1.1)
        buttonTrigger?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') openSubmenu(e);
        });
      }
    });

    this.querySelectorAll('.header__submenu .has-sub-menu').forEach(item => {
      const linkedTrigger = item.querySelector(':scope > a.header__menu-item[href]');
      const toggleButton = item.querySelector(':scope > .header-submenu-toggle');
      const buttonTrigger = item.querySelector(':scope > .header__menu-item[role="button"]');
      const trigger = linkedTrigger ? toggleButton : buttonTrigger;

      if (!trigger) return;

      const toggleSubmenu = e => {
        e.preventDefault();
        e.stopPropagation();
        item.classList.remove(this.escapeClosedClass);

        const isOpen = item.classList.contains('submenu-open');
        const parentSubmenu = item.parentElement?.parentElement;

        parentSubmenu?.querySelectorAll('.has-sub-menu.submenu-open').forEach(openItem => {
          if (openItem === item) return;

          openItem.classList.remove('submenu-open');
          openItem.querySelector(':scope > .header-submenu-toggle, :scope > .header__menu-item[role="button"]')?.setAttribute('aria-expanded', 'false');
        });

        item.classList.toggle('submenu-open', !isOpen);
        trigger.setAttribute('aria-expanded', (!isOpen).toString());
        this.syncHeaderMenuAria();
      };

      trigger.addEventListener('click', toggleSubmenu);

      // When the trigger is a role="button" div (no linked URL), Enter/Space must activate it (a11y: WCAG 2.1.1)
      if (!linkedTrigger) {
        trigger.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') toggleSubmenu(e);
        });
      }
    });

    document.addEventListener('click', () => {
      if (this.headerBgOverlay?.classList.contains('active')) {
        this.closeAll();
      }
    });

    this.drawerSearch?.addEventListener('click', () => this.openDrawer(!this.drawerMark.classList.contains('drawer-open')));
    this.drawerOverlay?.addEventListener('click', () => this.openDrawer(false));
    this.drawerSerchClose?.addEventListener('click', () => this.openDrawer(false));

  }

  clearEscapeClosedState() {
    this.querySelectorAll(`.${this.escapeClosedClass}`).forEach(item => item.classList.remove(this.escapeClosedClass));
  }

  getTopLevelMenuTrigger(item) {
    const topLevelLink = item?.querySelector(':scope > a.header-menu-item[href]');
    return topLevelLink ? item.querySelector(':scope > .header-menu-toggle') : item?.querySelector(':scope > .header-menu-item[role="button"]');
  }

  getSubmenuTrigger(item) {
    const linkedTrigger = item?.querySelector(':scope > a.header__menu-item[href]');
    return linkedTrigger ? item.querySelector(':scope > .header-submenu-toggle') : item?.querySelector(':scope > .header__menu-item[role="button"]');
  }

  hasFocusWithin(element) {
    return !!element && element.contains(document.activeElement);
  }

  syncHeaderMenuAria() {
    this.menuItems.forEach(item => {
      const trigger = this.getTopLevelMenuTrigger(item);
      if (!trigger) return;

      const parentItem = item.closest('li');
      const isClickOpen = parentItem?.classList.contains(this.activeParentClass);
      const isFocusOpen = !item.classList.contains('has-linked-menu-label') &&
        !item.classList.contains(this.escapeClosedClass) &&
        this.hasFocusWithin(item);

      trigger.setAttribute('aria-expanded', isClickOpen || isFocusOpen ? 'true' : 'false');
    });

    this.querySelectorAll('.header__submenu .has-sub-menu').forEach(item => {
      const trigger = this.getSubmenuTrigger(item);
      if (!trigger) return;

      const isClickOpen = item.classList.contains('submenu-open');
      const isFocusOpen = !item.classList.contains('has-linked-menu-label') &&
        !item.classList.contains(this.escapeClosedClass) &&
        this.hasFocusWithin(item);

      trigger.setAttribute('aria-expanded', isClickOpen || isFocusOpen ? 'true' : 'false');
    });
  }

  scheduleHeaderMenuAriaSync() {
    window.requestAnimationFrame ? window.requestAnimationFrame(() => this.syncHeaderMenuAria()) : setTimeout(() => this.syncHeaderMenuAria(), 0);
  }

  onHeaderMenuFocusIn(event) {
    if (!event.target.closest('.header-menu')) return;
    this.scheduleHeaderMenuAriaSync();
  }

  onHeaderMenuFocusOut(event) {
    const menuItem = event.target.closest('.has-sub-menu');
    const nextTarget = event.relatedTarget;

    if (menuItem && (!nextTarget || !menuItem.contains(nextTarget))) {
      menuItem.classList.remove(this.escapeClosedClass);
    }

    setTimeout(() => this.syncHeaderMenuAria(), 0);
  }

  onHeaderMenuKeydown(event) {
    if (event.key !== 'Escape' || !event.target.closest('.header-menu')) return;

    const topLevelItem = event.target.closest('.main-menu-has-sub-menu');
    const nestedItem = event.target.closest('.header__submenu .has-sub-menu');
    const focusTarget = topLevelItem ? this.getTopLevelMenuTrigger(topLevelItem) : this.getSubmenuTrigger(nestedItem);

    if (!topLevelItem && !nestedItem && !this.headerBgOverlay?.classList.contains('active')) return;

    event.preventDefault();
    event.stopPropagation();

    nestedItem?.classList.add(this.escapeClosedClass);
    topLevelItem?.classList.add(this.escapeClosedClass);
    this.closeAll({ preserveEscapeClosed: true });
    this.syncHeaderMenuAria();
    focusTarget?.focus();
  }

  closeAll({ preserveEscapeClosed = false } = {}) {
    if (!preserveEscapeClosed) this.clearEscapeClosedState();
    this.headerBgOverlay?.classList.remove('active');
    this.body.classList.remove('drawer-open-header');
    this.headerMenu?.classList.remove(this.activeHeaderClass);
    document.querySelectorAll(`.${this.activeParentClass}`).forEach(li => li.classList.remove(this.activeParentClass));
    document.querySelectorAll('.disclosure').forEach(disclosure => disclosure.classList.remove(this.activeDisclosureParentClass));
    this.querySelectorAll('.header-menu-toggle, .main-menu-has-sub-menu > .header-menu-item[role="button"]').forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    this.querySelectorAll('.header__submenu .submenu-open').forEach(item => {
      item.classList.remove('submenu-open');
      item.querySelector(':scope > .header-submenu-toggle, :scope > .header__menu-item[role="button"]')?.setAttribute('aria-expanded', 'false');
    });
    this.syncHeaderMenuAria();
  }

  handleScroll() {
    if (!this.headerMenu || !this.headerGroupArea) return;

    const menuCss = this.headerMenu.getAttribute('data-css') || '';
    const menuCsd = this.headerMenu.getAttribute('data-csd') || '';
    const stickyMode = this.dataset.sticky;
    const triggerOffset = parseInt(this.headerGroupArea.groupHeight) || 0;
    const currentScroll = window.pageYOffset;

    if (stickyMode === "scroll-down") {

      if (currentScroll > triggerOffset) {
        this.classList.add("sticky");
        if (currentScroll < this.lastScroll) {
          this.classList.add("is-visible");
          this.headerMenu.classList.replace(menuCsd, menuCss);
        } else {
          this.classList.remove("is-visible");
        }
      } else {
        this.classList.remove("sticky", "is-visible");
        this.headerMenu.classList.replace(menuCss, menuCsd);
      }

      this.lastScroll = Math.max(0, currentScroll);
    }
  }

  openMenu() {
    this.menuDrawer?.classList.add("menu-opening");
    this.menuIcon?.setAttribute("aria-expanded", "true");
    this.body?.classList.add("overflow-hidden");
    this.htmlElement?.classList.add("overflow-hidden");
  }

  closeMenu() {
    this.menuDrawer?.classList.remove("menu-opening");
    this.menuIcon?.setAttribute("aria-expanded", "false");
    this.body?.classList.remove("overflow-hidden");
    this.htmlElement?.classList.remove("overflow-hidden");
    this.menuIcon?.focus();
  }

  isMenuOpen() {
    return !!this.menuDrawer?.classList.contains("menu-opening");
  }

  onDocumentPointerDown(event) {
    if (!this.isMenuOpen()) return;
    // Ignore the toggle itself, otherwise this fires before the click handler
    // and the menu reopens immediately.
    if (this.menuIcon?.contains(event.target)) return;
    const panel = this.menuDrawer?.querySelector("#drawer-menu");
    if (panel && panel.contains(event.target)) return;
    this.closeMenu();
  }

  onDocumentKeydown(event) {
    if (!this.isMenuOpen()) return;
    if (event.key === "Escape" || event.key === "Esc") {
      this.closeMenu();
    }
  }

  onMenuKeydown(event) {
    // Native <button>/<summary> get Enter/Space for free; this <div role="button">
    // does not, so activate it on Enter and Space for keyboard users.
    if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
      event.preventDefault();
      this.toggleMenu();
    }
  }

  onSearchDrawerKeydown(event) {
    if (event.key === "Escape" || event.key === "Esc") {
      event.preventDefault();
      this.openDrawer(false);
    }
  }

  toggleMenu() {
    const shouldOpen = !this.menuDrawer?.classList.contains("menu-opening");
    this.menuDrawer?.classList.toggle("menu-opening", shouldOpen);
    this.menuIcon?.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
    this.body?.classList.toggle("overflow-hidden", shouldOpen);
    this.htmlElement?.classList.toggle("overflow-hidden", shouldOpen);
  }
}


if (!customElements.get("header-minmize")) {
  customElements.define("header-minmize", HeaderMinimize);
}



function initCustomHeader() {
  customElements.whenDefined('header-minmize').then(() => {
    document.querySelectorAll('header-minmize').forEach(el => {
      el.connectedCallback?.();
    });
  });

  customElements.whenDefined('header-group-area').then(() => {
    document.querySelectorAll('header-group-area').forEach(el => {
      el.connectedCallback?.();
    });
  });
}


document.addEventListener('shopify:section:load', initCustomHeader);
document.addEventListener('shopify:section:unload', initCustomHeader);
document.addEventListener('shopify:section:reorder', initCustomHeader);
